import axios from "axios";
import { API_BASE_URL } from "../constants";

/**
 * Fetch casino content
 * @param {string} casinoId
 * @returns {Object}  casino content
 */
export const getCasinoContent = async (casinoId) => {
  try {
    const url = `${API_BASE_URL}api/casino-content/${casinoId}`;

    const response = await axios.get(url);
    const data = response.data[0];

    return data || {};
  } catch (error) {
    console.error("Error fetching casino content:", error);
    return {};
  }
};
